import React from 'react';
import './App.css';
import Home from './components/home/home';

function App() {
  return (
    <React.StrictMode>
      <Home />
    </React.StrictMode>
  )
}

export default App;
